/**
 * Task_Entity type guard.
 *
 * @param {any} taskJson Task object from API
 * @returns {boolean} Return true if type is Task_Entity
 */
function validator(taskJson: unknown): taskJson is Task_Entity {
  if (typeof taskJson === "object" && taskJson != null) {
    Task_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(taskJson).includes(element))
        console.log("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Task_Entity {
  static requiredFields = [
    "id",
    "name",
    "description",
    "createdAt",
    "updatedAt",
  ];

  constructor(taskJson: unknown) {
    if (validator(taskJson)) {
      this.id = taskJson.id;
      this.name = taskJson.name;
      this.color = taskJson.color;
      this.description = taskJson.description;
      this.createdAt = taskJson.createdAt;
      this.updatedAt = taskJson.updatedAt;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Task_Entity.name }: ${e}"
      );
    }
  }

  id: number;
  name?: string;
  color?: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}
